<div igxToggle #waitIndicator>
    <div style="display: flex;">
        <igx-circular-bar [animate]="false" [indeterminate]="true" [textVisibility]="false" style="width: 200px; height: 200px;"></igx-circular-bar>
    </div>
</div>
